import React from 'react';
import { Typography } from '@mui/material';
import { useSelector } from 'react-redux';
import { IValuationState } from 'dashboard409a/states/features/valuation';
import { RootStateType } from 'dashboard409a/states/store';
import { formatMD } from 'dashboard409a/utilities';
import { DisclaimerContainer } from './Disclaimer.styles';

// Light blue disclaimer banner at the bottom of the Overview (redesign).
const Disclaimer = () => {
  const { currentCompany } = useSelector((state: RootStateType) => state.global);
  const { currentValuationScalarOpinion } = useSelector<RootStateType, IValuationState>(state => state.valuation);

  const measurementDate = currentValuationScalarOpinion?.report_date?.measurement_date?.date;
  if (!currentCompany?.name || !measurementDate) {
    return null;
  }

  return (
    <DisclaimerContainer>
      <Typography sx={{ color: '#1774D1', fontWeight: 700, mb: 1.5 }}>Disclaimer</Typography>
      <Typography sx={{ color: '#3D8FE5', fontSize: '0.95rem' }}>
        A valuation engagement for <b>{currentCompany.name}</b> was conducted as of{' '}
        {formatMD({ date: measurementDate, format: 'MMMM D, YYYY' })}, based on the company&apos;s historical and
        forecasted financial condition, assuming it remains a going concern. The analysis, developed in accordance with
        AICPA standards, reflects Scalar&apos;s unbiased professional opinions and conclusions.
      </Typography>
      <Typography sx={{ color: '#3D8FE5', fontSize: '0.75rem', fontStyle: 'italic', mt: 1.5 }}>
        This dashboard is for reference only; please refer to the PDF for the final report.
      </Typography>
    </DisclaimerContainer>
  );
};

export default Disclaimer;
